import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { clickEvents } from '../../utils/analytics';

const FindConstructionJobs = () => {
  return (
    <div className="ptp-splash-page__find-construction-jobs">
      <div>
        <p className="ptp-splash-page__card-title">
          Find Construction Jobs
        </p>
        <p className="ptp-splash-page__p">
          Interested in applying to trades jobs yourself? You can also use the Path to Pro Network to find your next job in the trades.
        </p>
        <p className="ptp-splash-page__p">
          Access a{' '}
          <a
            className="ptp-splash-page__hyperlink"
            target="_blank"
            rel="noreferrer"
            onClick={() => clickEvents.homePageResourceLinksClick('step by step guide')}
            href="https://cdn-static.findly.com/wp-content/uploads/sites/3285/2025/04/09174311/Path-to-Pro-Network-Profile-Setup-Guide_2025.pdf"
          >step-by-step
          </a>
          {' '}guide to build your Network profile.
        </p>
      </div>
      <div>
        <Button
          variant="secondary"
          onClick={() => {
            window.open('https://thehomedepot.worksuite.com/invite/0bf0d5ad9a71490681c3f30c79c7c7fe/');
            clickEvents.jobSeekersButtons('sign up');
          }}
        >
            Find a Job
        </Button>
      </div>
    </div>
  );
};
export default FindConstructionJobs;
